export default "__VITE_ASSET__AHZ8Xysk__"